import { Brand, createBranded } from '@deltasierra/type-utilities';
import { OwnableIntegrationResource, EmailAddress, FullAuditable, HasId } from '../common';
import {
    GoogleMyBusinessAccountResourceId,
    GoogleMyBusinessLocationResourceId,
    LinkedInOrganizationUrn,
} from '../integration';

export type IntegrationConfigurationId = Brand<number, 'IntegrationConfigurationId'>;
export const IntegrationConfigurationId = createBranded<IntegrationConfigurationId>();

export interface IntegrationConfiguration
    extends HasId<IntegrationConfigurationId>,
    FullAuditable,
    OwnableIntegrationResource {
    clubReadyChainId: string[] | null;
    clubReadyClubId: string | null;
    crmSenderName: string | null;
    glofoxBranchId: string | null;
    facebookPageId: string | null;
    facebookPageName: string | null;
    fitwareAccountId: number | null;
    fitwareClubBrand: string | null;
    fitwareClubEmail: EmailAddress | null;
    fitwareClubName: string | null;
    fitwareClubNumber: string | null;
    googleAdWordsCampaignName: string | null;
    googleAdWordsCustomerId: string | null;
    googleAnalyticsPagePath: string | null;
    googleAnalyticsPropertyId: string | null;
    googleAnalyticsViewId: string | null;
    googleMyBusinessAccountName: GoogleMyBusinessAccountResourceId | null;
    googleMyBusinessLocationId: GoogleMyBusinessLocationResourceId | null;
    gymSalesCompanyId: string | null;
    gymSalesCompanyName: string | null;
    instagramPageId: string | null;
    instagramPageName: string | null;
    instagramFacebookPageId: string | null;
    instagramFacebookPageName: string | null;
    kiteLocationId: string | null;
    linkedInOrganizationUrn: LinkedInOrganizationUrn | null;
    mailOpsClientId: string | null;
    mailchimpServer: string | null;
    marianaTekSubdomain: string | null;
    marianaTekStudioId: number | null;
    zenotiCenterId: string | null;
    mindbodySiteId: number | null;
}
